import React from 'react';
import { X } from 'lucide-react';
import { FOCUS_RING } from '../form/styles';

interface CloseButtonProps {
  onClick: () => void;
  disabled?: boolean;
  // Posizionamento e visibilità decisi dalla modale (es. 'absolute top-4 right-4')
  className?: string;
}

// Pulsante di chiusura unico per tutte le modali (stile della modale "Invita gli amici")
const CloseButton = ({ onClick, disabled = false, className = '' }: CloseButtonProps) => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled}
    aria-label="Chiudi"
    className={`group flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-fpcpink hover:bg-fpcred transition-all ${FOCUS_RING} disabled:pointer-events-none disabled:opacity-50 ${className}`}>
    <X className="h-7 w-7 text-fpcred group-hover:text-white transition-colors" strokeWidth={3} />
  </button>
);

export default CloseButton;
